export default __webpack_public_path__ + "static/media/assistant44.7722abd1.png";